import { Outlet } from "react-router";

export function SecondaryLayout() {
  return (
    <main className="grow bg-lightGray">
      <Outlet />
    </main>
  );
}
